<template>
    <div class="privacy-policy">
      <!-- Banner Section -->
      <div class="banner">
      <h1>Privacy policy</h1>
    </div>
  
      <!-- Main Content -->
      <section class="policy-content">
        <h2>Privacy policy</h2>
        <p class="introduction">
            当社ではお客様からのお問い合わせに際しまして、お客様の個人情報をお預かりいたします。お預かりした個人情報は下記の通りに厳重に管理保護してまいります。
        </p>
  
        <div class="policy-section">
          <ol>
            <li>
              <strong>（個人情報保護管理者）</strong><br/>
              桜倉製薬株式会社 管理本部長
            </li>
            <li>
              <strong>（利用目的）</strong><br/>
              お問い合せに関するご回答のため<br/>
              弊社サービス案内のための対応
            </li>
            <li>
              <strong>（第三者への提供と委託）</strong><br/>
              当社では法令に基づく場合を除きましては、お預かりした個人情報は原則第三者への提供はいたしません。
            </li>
            <li>
              <strong>（任意のご提供）</strong><br/>
              個人情報の提供は任意といたします。お客様からのサービスに必要な個人情報をご提供いただけない場合は、サービスの提供を行う事ができない場合があります。その場合は個人情報の提供が必要である旨を明示致します。</li>
            <li>
              <strong>（個人情報の開示等について）</strong><br/>
              お客様には、当社に提出していただいた個人情報について、開示を求めることができます。また誤った情報については訂正・削除等の要求が可能です。
            </li>
            <li>
              <strong>（ 取得する個人情報の項目）</strong><br/>
              氏名・住所・電話番号・メールアドレス、用途、項目、ご注文・お問合せ・利用・提供の対応に関して
(なお、弊社では上記の個人情報に関し、取得・利用・管理・訂正・追加・削除・利用・提供の内容を遵守し、必要に応じて窓口までご連絡ください。)
            </li>
          </ol>
        </div>
  
        <div class="contact">
          <h3>（個人情報相談窓口）</h3>
          <p>
            桜倉製薬株式会社 個人情報相談窓口：管理本部長<br/>
            本社：〒104-0061 東京都中央区銀座一丁目１６番７号<br/>
            電話：03-6737-7559<br/>
            お客様窓口：0120-58-0916<br/>
            Email：info@sakurapharma.com
          </p>
        </div>
      </section>
    </div>
  </template>
  
  <style scoped>
  .privacy-policy {
    font-family: 'Noto Sans JP', sans-serif;
    color: #333;
    background-color: #fff;
  }
  
  .banner {
  background: url('@/assets/b00f67c23bac49018bf44a77582e60a7.png') no-repeat center/cover;
  text-align: center;
  padding: 60px 0;
  color: #8d6e52;
}

.banner h1 {
  text-align: center;
  font-size: 36px;
  margin: 40px 0;
  font-family: 'Hiragino Sans', 'Noto Sans JP', sans-serif; /* 添加黑体字体 */
  font-weight: 400; /* 取消加粗 */
  color: #666;
}

.banner p {
  font-size: 18px;
}

  
  
  .policy-content {
    max-width: 1000px;
    margin: 40px auto;
    padding: 0 20px;
    text-align: left;
  }
  
  .policy-content h2 {
    font-size: 1.9rem;
  margin-bottom: 25px;
  font-family: "HiraMinProN-W3", "Hiragino Mincho Pro", serif;
  font-weight: 400;
  letter-spacing: 0.1em;
  color: #2a2a2a;
  position: relative;
  padding-bottom: 15px;
  text-align: center;
  }

  .policy-content h2::after {
    content: "";
  position: absolute;
  bottom: 0;
  left: 46%;
  width: 50px;
  height: 2px;
  background: linear-gradient(90deg, #f8d7a3, #f5b8ca);
  }
  
  
  .policy-content .introduction {
    font-weight: bold;
    margin: 30px 0;
    line-height: 1.8;
  }
  
  .policy-section ol {
    padding-left: 20px;
    line-height: 1.8;
    font-size: 0.95rem;
  }
  
  .policy-section ol li {
    margin-bottom: 1em;
  }
  
  .contact h3 {
    margin-top: 40px;
    font-size: 1rem;
  }
  
  .contact p {
    font-size: 0.9rem;
    line-height: 1.6;
  }
  
  
  /* 新增移动端样式 */
  @media (max-width: 768px) {
    .policy-content h2 {
      display: none; /* 隐藏标题 */
    }
    
    .policy-content .introduction {
      margin-top: 0; /* 上移内容 */
    }
  }
</style>